<div class="fixed inset-0 z-[9999] flex items-center justify-center p-4">
  <div class="absolute inset-0 bg-slate-950/60 backdrop-blur-md animate-fade-in" (click)="!loading && onCancel()"></div>
  <div
    class="relative bg-white dark:bg-slate-900 rounded-[32px] shadow-2xl w-full max-w-md p-8 text-center animate-scale-up border border-white/20 dark:border-slate-800/50">
    <div class="mx-auto flex items-center justify-center h-20 w-20 rounded-full mb-6 shadow-inner"
      [ngClass]="variant === 'danger' ? 'bg-rose-50 dark:bg-rose-900/30' : 'bg-amber-50 dark:bg-amber-900/30'">
      <span class="material-icons-outlined text-4xl"
        [ngClass]="variant === 'danger' ? 'text-rose-500' : 'text-amber-500'">{{ icon }}</span>
    </div>

    <h3 class="text-xl font-black text-slate-800 dark:text-white mb-2 tracking-tight">{{ title }}</h3>

    <p class="text-sm text-slate-500 dark:text-slate-400 mb-4 leading-relaxed">
      <ng-container *ngIf="message">{{ message }}</ng-container>
      <span *ngIf="highlight"
        class="font-black text-slate-800 dark:text-slate-200 bg-slate-100 dark:bg-slate-800 px-2 py-1 rounded-lg mx-1">
        {{ highlight }}
      </span>
      <ng-container *ngIf="messageSuffix">{{ messageSuffix }}</ng-container>
      <br *ngIf="showIrreversibleNote">
      <span *ngIf="showIrreversibleNote" class="text-rose-500 font-bold mt-1 inline-block">
        * การกระทำนี้ไม่สามารถย้อนกลับได้
      </span>
    </p>

    <div *ngIf="requireRemark" class="mb-6 text-left">
      <label class="block text-xs font-bold text-slate-600 dark:text-slate-300 mb-1.5">
        {{ remarkLabel }} <span class="text-rose-500">*</span>
      </label>
      <textarea
        [ngModel]="remark"
        (ngModelChange)="onRemarkInput($event)"
        [disabled]="loading"
        rows="3"
        [placeholder]="remarkPlaceholder"
        class="w-full rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/80 px-3 py-2.5 text-sm text-slate-800 dark:text-slate-100 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-rose-400/40 focus:border-rose-400 disabled:opacity-50 resize-none">
      </textarea>
      <p *ngIf="!remark?.trim()" class="mt-1 text-[11px] font-semibold text-rose-500">
        ต้องระบุหมายเหตุก่อนยืนยันการลบ
      </p>
    </div>

    <div class="grid grid-cols-2 gap-3" [class.mt-4]="!requireRemark">
      <button type="button" (click)="onCancel()" [disabled]="loading"
        class="w-full py-3 text-sm font-bold text-slate-500 hover:bg-slate-50 dark:hover:bg-slate-800 rounded-xl transition-all border border-slate-200 dark:border-slate-800 disabled:opacity-40 disabled:cursor-not-allowed">
        {{ cancelLabel }}
      </button>
      <button type="button" (click)="onConfirm()" [disabled]="!canConfirm"
        class="w-full py-3 text-white rounded-xl text-sm font-bold shadow-lg active:scale-95 transition-all disabled:opacity-70 disabled:cursor-not-allowed inline-flex items-center justify-center gap-2"
        [ngClass]="variant === 'danger'
          ? 'bg-rose-600 hover:bg-rose-700 shadow-rose-600/20'
          : 'bg-amber-500 hover:bg-amber-600 shadow-amber-500/20'">
        <span *ngIf="loading" class="inline-block w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></span>
        {{ loading ? loadingLabel : confirmLabel }}
      </button>
    </div>
  </div>
</div>
